import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownOption',
    baseStyle: {
      borderBottom: `1px solid ${theme.colors.spark.gray80}`,
      backgroundColor: theme.colors.spark.gray90,

      ['&:last-child']: {
        border: 'none'
      },

      ['&:hover']: {
        backgroundColor: theme.colors.spark.gray80
      }
    }
  };
}
